// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"246":"b2c653dc125131a587b9","940":"d975adf78921906020e8"}[chunkId] + ".css";
};